import { ChangeDetectorRef, Component, HostListener, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from 'src/app/core/services/toast.service';
import { Plan } from 'src/app/core/services/plan.service';
import { LazyLoadEvent } from 'primeng/api';
import { Table } from 'primeng/table';
import { Customer, CustomerService } from 'src/app/core/services/customer.service';
import { UserProfileService } from 'src/app/core/services/user.service';
@Component({
  selector: 'app-estamp-customer',
  templateUrl: './estamp-customer.component.html',
  styleUrl: './estamp-customer.component.scss'
})
export class EstampCustomerComponent {

  customers: Customer[] = [];
  plans: Plan[] = [];
  loading = false;
  error = '';
  term: any;
  breadCrumbItems: Array<{}>;

  editForm!: UntypedFormGroup;
  modalRef!: NgbModalRef;
  editingCustomer: Customer | null = null;
  paymentType: any = ['COD', 'Online'];
  selectedPaymentMode: string = 'COD';
  @ViewChild('dt') table!: Table;

  totalRecords = 0;
  rows = 10;
  searchText = '';
  selectedStatus: string = '';
  selectedplan: string = '';
  rangeDates: Date[] | null = null;

  statusOptions = [
    { label: 'All', value: '' },
    { label: 'Active', value: 'ACTIVE' },
    { label: 'Inactive', value: 'INACTIVE' },
    { label: 'Requested', value: 'REQUESTED' }
  ];

  constructor(
    private userService: CustomerService,
    private toastService: ToastService,
    private cdr: ChangeDetectorRef,
    private modalService: NgbModal,
    private userProfileService: UserProfileService,
  ) {
    this.breadCrumbItems = [{ label: 'AVSS eSign' }, { label: 'Estamp' }, { label: 'Customers', active: true }];
  }

  ngOnInit(): void { }

  loadCustomers(event: LazyLoadEvent) {
    this.loading = true;
    this.cdr.detectChanges();
    const first = event?.first ?? 0;
    const rows = event?.rows ?? this.rows;
    const page = first / rows + 1;
    let startDate: string | null = null;
    let endDate: string | null = null;

    if (this.rangeDates && this.rangeDates.length === 2) {
      startDate = this.formatDate(this.rangeDates[0]);
      endDate = this.formatDate(this.rangeDates[1]);
    }

    const queryParams = {
      page: page,
      limit: rows,
      search: this.searchText,
      status: this.selectedStatus,
      plan: this.selectedplan,
      startDate: startDate,
      endDate: endDate
    };
    this.userService.getEstampCustomers(queryParams).subscribe({
      next: (res: any) => {
        this.customers = res?.data || [];
        this.totalRecords = res?.meta?.total ?? 0;
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: () => {
        this.loading = false;
        this.cdr.detectChanges();
      }
    });
  }

  selectedCustomer: any = null;
  makers: any[] = [];
  selectedMakerId: string = '';

  assigning = false;

  assignedMaker(customer: any, content: any) {
    this.selectedCustomer = customer;
    this.selectedMakerId = '';
    this.activeMenuId = null;
    this.makers = [];
    customer?.estampService === 'REQUESTED' ? this.getMaker() : '';
    customer?.userId ? this.selectedMakerId = customer?.userId : '';
    this.modalRef = this.modalService.open(content, { size: 'md' });
  }

  getMaker() {
    const paarams = {}
    this.userProfileService.getUsers(paarams).subscribe({
      next: (res: any) => {
        this.makers = res?.data || [];
        this.cdr.detectChanges();
      },
      error: () => { }
    });
  }

  submitAssignMaker() {
    if (!this.selectedMakerId) {
      this.toastService.showToaster('Failed', 'Please select a maker', 'error');
      return;
    }



    const payload = {
      clientEmail: this.selectedCustomer?.email,
      userId: this.selectedMakerId,
    }

    this.assigning = true;
    this.userProfileService.assignMaker(payload).subscribe({
      next: (res: any) => {
        this.assigning = false;
        this.closeModal();
        this.table?.reset();
        this.getMaker()
        this.toastService.showToaster('Success', res?.message || 'Maker assigned successfully', 'success');
      },
      error: () => {
        this.assigning = false;
      }
    });
  }

  formatDate(date: Date): string {
    const y = date.getFullYear();
    const m = (date.getMonth() + 1).toString().padStart(2, '0');
    const d = date.getDate().toString().padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  filterChange(event: any) {
    this.selectedStatus = event.status;
    this.selectedplan = event.plan;
    this.searchText = event.search;
    this.rangeDates = event.dateRange
    this.table?.reset();
  }

  activeMenuId: string | null = null;
  @HostListener('document:click', ['$event'])
  clickOutside(event: any) {
    if (!event.target.closest('.action-wrapper')) {
      this.activeMenuId = null;
    }
  }
  toggleMenu(id: string) {
    this.activeMenuId = this.activeMenuId === id ? null : id;
  }

  closeModal() {
    this.firstParty = '';
    this.emailRecipients = '';
    this.emailRecipientsTouched = false;
    this.emailRecipientsInvalid = false;
    if (this.modalRef) {
      this.modalRef.dismiss();
    }
  }

  openModal(content: any) {
    this.modalRef = this.modalService.open(content, { size: 'md' });
  }

  configCustomer: any = null;
  lossPolicyMode: string = 'MAX_AMOUNT';
  maxLossAmount: number | null = null;
  maxLossPercentage: number | null = null;
  configReason: string | null = null;
  firstParty: string | null = null;
  serviceChargeRate: any = null;
  emailRecipients: string | null = null;
  emailRecipientsTouched = false;
  emailRecipientsInvalid = false;
  loadingConfig = false;
  savingConfig = false;

  confingModal(customer: any, content: any) {
    this.configCustomer = customer;
    this.activeMenuId = null;
    this.lossPolicyMode = 'MAX_AMOUNT';
    this.maxLossAmount = null;
    this.maxLossPercentage = null;
    this.configReason = '';
    this.firstParty = '';
    this.serviceChargeRate = null;
    this.emailRecipients = '';
    this.emailRecipientsTouched = false;
    this.emailRecipientsInvalid = false;
    this.loadingConfig = true;
    this.modalRef = this.modalService.open(content, { size: 'md' });

    this.userService.getClientConfig(customer?.email).subscribe({
      next: (res: any) => {
        const { stamp, serviceChargeRate, emailRecipients, reason } = res.data
        const lossPolicy = stamp?.lossPolicy;
        if (lossPolicy) {
          this.lossPolicyMode = lossPolicy.mode || 'MAX_AMOUNT';
          this.maxLossAmount = lossPolicy.maxLossAmount ?? null;
          this.maxLossPercentage = lossPolicy.maxLossPercentage ?? null;
        }
        this.firstParty = stamp?.firstParty || '';
        this.serviceChargeRate = serviceChargeRate * 100
        this.emailRecipients = emailRecipients;
        this.configReason = reason;
        this.loadingConfig = false;
        this.cdr.detectChanges();
      },
      error: () => {
        this.loadingConfig = false;
        this.cdr.detectChanges();
      }
    });
  }

  submitConfig() {
    if (this.savingConfig) {
      return;
    }

    this.emailRecipientsTouched = true;

    const firstParty = this.firstParty?.trim() || null;

    const emailEntries = (this.emailRecipients ?? '')
      .split(',')
      .map(email => email.trim())
      .filter(email => !!email);

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    this.emailRecipientsInvalid = emailEntries.some(
      email => !emailPattern.test(email)
    );

    if (this.emailRecipientsInvalid) {
      return;
    }

    const seenEmails = new Set<string>();

    const cleanedEmails = emailEntries.filter(email => {
      const normalizedEmail = email.toLowerCase();

      if (seenEmails.has(normalizedEmail)) {
        return false;
      }

      seenEmails.add(normalizedEmail);
      return true;
    });

    const cleanedEmailRecipients =
      cleanedEmails.length > 0 ? cleanedEmails.join(', ') : null;

    this.firstParty = firstParty;
    this.emailRecipients = cleanedEmailRecipients;

    const lossPolicy: any = { mode: this.lossPolicyMode };

    if (this.lossPolicyMode === 'MAX_AMOUNT') {
      if (this.maxLossAmount === null || this.maxLossAmount === undefined || (this.maxLossAmount as any) === '') {
        this.toastService.showToaster('Failed', 'Please enter max loss amount', 'error');
        return;
      }
      lossPolicy.maxLossAmount = this.maxLossAmount;
    } else if (this.lossPolicyMode === 'MAX_PERCENTAGE') {
      if (this.maxLossPercentage === null || this.maxLossPercentage === undefined || (this.maxLossPercentage as any) === '') {
        this.toastService.showToaster('Failed', 'Please enter max loss percentage', 'error');
        return;
      }
      lossPolicy.maxLossPercentage = this.maxLossPercentage;
    }

    const payload = {
      stamp: {
        lossPolicy,
        firstParty
      },
      reason: this.configReason?.trim() || null,
      emailRecipients: cleanedEmailRecipients,
      serviceChargeRate: this.serviceChargeRate / 100
    };

    this.savingConfig = true;
    this.userService.updateClientConfig(this.configCustomer?.email, payload).subscribe({
      next: (res: any) => {
        this.savingConfig = false;
        this.closeModal();
        this.loadCustomers({});
        this.toastService.showToaster('Success', res?.message || 'Config updated successfully', 'success');
      },
      error: () => {
        this.savingConfig = false;
      }
    });
  }
}
